import "./LandingHeader.scss";
import React from "react";
import { IonIcon, IonText } from "@ionic/react";
import abaxxLogo from "../../assets/svg/logoAbaxx.svg";

interface Props {
  hidden?: boolean;
}

const LandingHeader: React.FC<Props> = ({ hidden }) => {
  return (
    <div className="landing-header" hidden={hidden}>
      <IonIcon icon={abaxxLogo} className="app-logo" />
      <IonText className="title">Welcome to Verifier</IonText>
    </div>
  );
};

export default LandingHeader;
